import {Item} from '../types/item';
import {CartItem} from '../types/cartItem';
import {decrypt, encrypt} from './crypto';

const CART_KEY = 'cart';

export function getCart(): CartItem[] {
    const stored = localStorage.getItem(CART_KEY);
    if (!stored) return [];
    const result = decrypt(stored);
    return Array.isArray(result) ? result : [];
}

export function saveCart(cart: CartItem[]): void {
    localStorage.setItem(CART_KEY, encrypt(cart as any));
}

export function addToCart(item: Item): void {
    const cart = getCart();
    const existing = cart.find(c => c.item.id === item.id);
    if (existing) {
        existing.quantity += 1;
    } else {
        cart.push({ item, quantity: 1 });
    }
    saveCart(cart);
}

export function removeFromCart(itemId: number): void {
    saveCart(getCart().filter(c => c.item.id !== itemId));
}

export function updateQuantity(itemId: number, quantity: number): void {
    if (quantity < 1) {
        removeFromCart(itemId);
        return;
    }
    const cart = getCart();
    const entry = cart.find(c => c.item.id === itemId);
    if (entry) {
        entry.quantity = quantity;
        saveCart(cart);
    }
}

export function clearCart(): void {
    localStorage.removeItem(CART_KEY);
}

export function getCartCount(): number {
    return getCart().reduce((sum, c) => sum + c.quantity, 0);
}

export function getCartTotal(): number {
    return getCart().reduce((sum, c) => {
        const price = c.item.priceAkcia > 0 ? c.item.priceAkcia : c.item.price;
        return sum + price * c.quantity;
    }, 0);
}
